import React from 'react';
import styled from 'styled-components';
import PlusIcon from '../icons/PlusIcon';
import { FONT } from 'theme/font';

const ButtonWrapper = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: 1px dashed ${props => props.isActive ? '#444CE7' : '#D0D5DD'};
  cursor: ${props => props.isActive ? 'pointer' : 'not-allowed'};
  color: ${props => props.isActive ? '#444CE7' : '#D0D5DD'};
  font-size: ${FONT.F_SM};
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s;
  width: 400px;
  height: 47px;

  &:hover {
    background: ${props => props.isActive ? 'rgba(68, 76, 231, 0.05)' : 'none'};
  }

  svg {
    width: 26px;
    height: 26px;
    path {
      stroke: ${props => props.isActive ? '#444CE7' : '#D0D5DD'};
    }
  }
`;


const AddAnotherButton = ({ onClick, text = "Add another assessment", isActive }) => {
  return (
    <ButtonWrapper onClick={isActive ? onClick : undefined} isActive={isActive}>
      <PlusIcon />
      {text}
    </ButtonWrapper>
  );
};

export default AddAnotherButton;